export const ADVISORY_ADDONS = [
  ["DIRECT_FINANCIAL_ACCESS", "Direct access for financial questions"],
  ["RECOMMENDATION_FOLLOW_UP", "Recommendation follow-up and measurement"],
  ["QUARTERLY_FORECASTING", "Quarterly forecasting and scenario planning"],
  ["CUSTOM_DATA_SOURCES", "Custom data source integrations"],
  ["CUSTOM_AI_SETUP", "Custom AI setup"],
];

export const ADVISORY_ADDON_LABELS = Object.fromEntries(ADVISORY_ADDONS);
